import { DeviceConfigurationStatus } from '@iot-platform/models/common';
import { noop } from 'rxjs';

import { I4BCellType, I4BColumnConfiguration, I4BGridFilterType } from './configurations';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { I4BBasicColumn, I4BColumn, I4BSelectionColumn, IdColumn, NameColumn, NtePeripheralsButtonColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { I4BColumnHeader, I4BGrid, I4BGridOptions, NtePeripheralsGridData } from './models';
import { I4BColumnOptions } from './options';

export const GET_DEFAULT_PERIPHERALS_COLUMNS_FOR_NTE_PERIPHERALS_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => [
  new IdColumn(
    {
      displayName: 'ID'
    },
    {
      id: 'id',
      concept: I4bCellConcept.PERIPHERALS,
      sortProperty: 'id',
      cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigateToPeripheralDetails' } },
      filterParams: {
        enabled: false
      },
      isDefault: true
    },
    { order: 1 }
  ),
  new NameColumn(
    { displayName: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.NAME' },
    {
      id: 'name',
      sortProperty: 'name',
      concept: I4bCellConcept.PERIPHERALS,
      cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigateToPeripheralDetails' } },
      filterParams: {
        enabled: false
      },
      isDefault: true
    },
    { order: 2 }
  ),
  new I4BBasicColumn(
    { displayName: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.STATUS' },
    {
      id: 'status',
      sortProperty: 'status',
      concept: I4bCellConcept.PERIPHERALS,
      cell: {
        type: I4BCellType.BASIC,
        cellClassRules: {
          'bg-green200 text-white!': 'value === "verified"',
          'bg-red300 text-white!': 'value === "deprecated"',
          'bg-orange-300 text-white!': 'value === "unverified"'
        }
      },
      filterParams: {
        enabled: false,
        filterType: I4BGridFilterType.SET_COLUMN_FILTER
      },
      isDefault: true
    },
    { order: 3 }
  )
];

export const DEFAULT_PERIPHERALS_MASTER_VIEW_NAME = 'nte-peripherals';

export class DefaultNtePeripheralsGrid implements I4BGrid<I4BGridOptions, NtePeripheralsGridData> {
  masterview = DEFAULT_PERIPHERALS_MASTER_VIEW_NAME;
  isDefault = false;
  isUserDefault = false;
  isAppDefault = false;
  name = DEFAULT_PERIPHERALS_MASTER_VIEW_NAME;
  userId: string | null = null;
  data: NtePeripheralsGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: true,
    autoRefresh: { enabled: false },
    gridSort: [{ colId: 'name', sort: 'asc', sortIndex: 0 }],
    buttonColumn: { enabled: false, className: new NtePeripheralsButtonColumn() },
    selectionColumn: { enabled: false, className: new I4BSelectionColumn(undefined, { concept: I4bCellConcept.PERIPHERALS }) },
    rowClassRules: {
      [DeviceConfigurationStatus.DRAFT]: `data.status === "${DeviceConfigurationStatus.DRAFT}"`,
      [DeviceConfigurationStatus.DESIRED]: `data.status === "${DeviceConfigurationStatus.DESIRED}"`,
      'bg-orange100': `data.status === "${DeviceConfigurationStatus.DRAFT}"`,
      'bg-blue100': `data.status === "${DeviceConfigurationStatus.DESIRED}"`
    }
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];

  export = () => noop();
}
